import { defineAsyncComponent } from 'vue';

export const addComponents = app => {
    return app.component('WatsonCtaBlock', defineAsyncComponent(() =>
        import('./cta-block/watson-theme-cta-block.vue'),
    )).component('WatsonFaq', defineAsyncComponent(() =>
        import('../../../components/organisms/faq/watson-organism-faq.vue'),
    )).component('WatsonHomeHeader', defineAsyncComponent(() =>
        import('./home-header/watson-theme-home-header.vue'),
    )).component('WatsonIconBlock', defineAsyncComponent(() =>
        import('./icon-block/watson-theme-icon-block.vue'),
    )).component('WatsonImageCard', defineAsyncComponent(() =>
        import('./image-card/watson-theme-image-card.vue'),
    )).component('WatsonListLogos', defineAsyncComponent(() =>
        import('./list-logos/watson-theme-list-logos.vue'),
    )).component('WatsonListPopularServices', defineAsyncComponent(() =>
        import('./list-popular-services/watson-theme-list-popular-services.vue'),
    )).component('WatsonListProfile', defineAsyncComponent(() =>
        import('./list-profile/watson-theme-list-profile.vue'),
    )).component('WatsonListServiceCategories', defineAsyncComponent(() =>
        import('./list-service-categories/watson-theme-list-service-categories.vue'),
    )).component('WatsonListStats', defineAsyncComponent(() =>
        import('./list-stats/watson-theme-list-stats.vue'),
    )).component('WatsonProfessionPriceList', defineAsyncComponent(() =>
        import('./profession-price-list/watson-theme-profession-price-list.vue'),
    )).component('WatsonQuoteBlock', defineAsyncComponent(() =>
        import('./quote-block/watson-theme-quote-block.vue'),
    )).component('WatsonReferences', defineAsyncComponent(() =>
        import('./references/watson-theme-references.vue'),
    )).component('WatsonTalkingAboutUsLarge', defineAsyncComponent(() =>
        import('./talking-about-us-large/watson-theme-talking-about-us-large.vue'),
    )).component('WatsonUsps', defineAsyncComponent(() =>
        import('./usps/watson-theme-usps.vue'),
    )).component('WatsonListMagazineArticles', defineAsyncComponent(() =>
        import('./list-magazine-articles/watson-theme-list-magazine-articles.vue'),
    ));
};
